<template>
  <div>
    <md-card>
      <md-card-header class="md-card-header-text md-card-header-green">
        <div class="card-text">
          <h4 class="title">نسخ احتياطي</h4>
        </div>
      </md-card-header>

      <md-card-content>
        <p class="mb-8">
          قم بإنشاء نسخة احتياطية من بيانات النظام. يمكنك اختيار النسخ السحابي
          للتخزين الآمن عبر الإنترنت، أو النسخ المحلي لحفظ البيانات على جهازك.
        </p>

        <md-field class="mb-8">
          <label>اسم النسخة الاحتياطية</label>
          <md-input
            v-model="backupName"
            placeholder="ادخل اسم النسخة الاحتياطية"
          ></md-input>
        </md-field>

        <div class="backup-actions">
          <md-button
            class="md-info md-raised"
            :loading="isCloudLoading"
            :disabled="isCloudLoading"
            @click="handleCloudBackup"
          >
            <md-progress-spinner
              v-if="isCloudLoading"
              :md-diameter="17"
              :md-stroke="3"
              md-mode="indeterminate"
            />
            <md-icon v-else>save</md-icon>

            نسخ احتياطي سحابي
          </md-button>

          <md-button
            class="md-success md-raised"
            :loading="isLocalLoading"
            :disabled="isLocalLoading"
            @click="handleLocalBackup"
          >
            <md-progress-spinner
              v-if="isLocalLoading"
              :md-diameter="17"
              :md-stroke="3"
              md-mode="indeterminate"
            />
            <md-icon v-else>save</md-icon>

            نسخ احتياطي محلي
          </md-button>

          <md-button
            class="md-warning md-raised"
            :loading="isUploading"
            :disabled="isUploading"
            @click="$refs.fileInput.click()"
          >
            <md-progress-spinner
              v-if="isUploading"
              :md-diameter="17"
              :md-stroke="3"
              md-mode="indeterminate"
            />
            <md-icon v-else>upload_file</md-icon>
            رفع نسخة احتياطية
          </md-button>
          <input
            type="file"
            ref="fileInput"
            accept=".zip"
            style="display: none"
            @change="handleFileUpload"
          />
        </div>

        <div v-if="lastBackup && showDownloadButton" class="download-section">
          <md-button
            class="md-primary md-raised md-block"
            @click="downloadLastBackup"
          >
            <md-icon>cloud_download</md-icon>
            تحميل النسخة الاحتياطية
          </md-button>
        </div>
      </md-card-content>
    </md-card>

    <div v-if="isRestoring" class="alert-container">
      <div class="alert">جاري استعادة النسخة الاحتياطية .....</div>
    </div>

    <TheTable
      :table-data="tableData"
      @handleRestore="handleRestore"
      @handleDelete="handleDelete"
    />
  </div>
</template>

<script>
import TheTable from "./TheTable.vue";

export default {
  components: { TheTable },
  data() {
    return {
      isUploading: false,
      isCloudLoading: false,
      isLocalLoading: false,
      isRestoring: false,
      backupName: undefined,
      tableData: [],
      lastBackup: null,
      showDownloadButton: false,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const { data } = await this.$axios.get("/api/backup/ListCloudBackups");

        this.tableData = data.data;
      } catch (error) {}
    },
    async handleCloudBackup() {
      this.isCloudLoading = true;
      try {
        this.$notify({
          timeout: 3000,
          message:
            "جاري تكوين النسخة الاحتياطية على السحابة، الرجاء الانتظار قليلا!!",
          icon: "add_alert",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success",
        });
        const { data } = await this.$axios.patch("/api/backup", {
          BackupName: this.backupName,
        });
        this.tableData.push(data.data);
        this.lastBackup = data.data;
        this.showDownloadButton = true;
        this.backupName = undefined;
        this.$notify({
          timeout: 3000,
          message: "تم إنشاء النسخة الاحتياطية بنجاح",
          icon: "add_alert",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success",
        });
      } catch (error) {
        this.$notify({
          timeout: 3000,
          message: "حدث خطأ أثناء إنشاء النسخة الاحتياطية",
          icon: "add_alert",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "error",
        });
      } finally {
        this.isCloudLoading = false;
      }
    },
    async handleLocalBackup() {
      this.isLocalLoading = true;
      try {
        const { data } = await this.$axios.patch(
          "/api/backup/createLocal",
          {
            BackupName: this.backupName,
          },
          { responseType: "blob" }
        );

        let fileName = undefined;

        if (this.backupName) {
          fileName = this.backupName + ".zip";
        } else {
          fileName = this.generateBackupFilename();
        }

        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.$notify({
          timeout: 3000,
          message: "تم إنشاء النسخة الاحتياطية بنجاح",
          icon: "add_alert",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success",
        });
      } catch (error) {
        this.$notify({
          timeout: 3000,
          message: error.response?.data?.message,
          icon: "add_alert",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "error",
        });
      } finally {
        this.isLocalLoading = false;
      }
    },
    generateBackupFilename() {
      const date = new Date();
      return `NanoSoft.HR-${date.getFullYear()}-${
        date.getMonth() + 1
      }-${date.getDate()}-${String(date.getHours()).padStart(2, "0")}${String(
        date.getMinutes()
      ).padStart(2, "0")}${String(date.getSeconds()).padStart(2, "0")}.zip`;
    },
    async handleRestore(item) {
      const confirmed = await this.$confirm(
        "هل أنت متأكد من استعادة النسخة الاحتياطية؟",
        "تأكيد الاستعادة",
        {
          confirmButtonText: "نعم",
          cancelButtonText: "لا",
          type: "warning",
          class: "rtl-dialog",
          customClass: "rtl-dialog",
          center: false,
        }
      ).catch(() => false);

      if (!confirmed) return;

      this.isRestoring = true;

      const params = {
        BackupName: item.databaseName,
      };

      try {
        const { data } = await this.$axios.post(
          `/api/backup/restore`,
          {},
          {
            params,
          }
        );

        if (data) {
          this.$notify({
            timeout: 1000,
            message: "تم استعادة النسخة الاحتياطية بنجاح",
            icon: "add_alert",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success",
          });

          setTimeout(() => {
            localStorage.clear();
            this.$router.replace("/");
          }, 500); // 1 second delay
        }
      } catch (error) {
        this.$notify({
          timeout: 3000,
          message: "حدث خطأ أثناء استعادة النسخة الاحتياطية",
          icon: "add_alert",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "error",
        });
      } finally {
        this.isRestoring = false;
      }
    },
    downloadLastBackup() {
      if (this.lastBackup) {
        window.open(this.lastBackup.path, "_blank");
        this.showDownloadButton = false;
      }
    },
    async handleDelete(backup) {
      const confirmed = await this.$confirm(
        "هل أنت متأكد من حذف النسخة الاحتياطية؟",
        "تأكيد الحذف",
        {
          confirmButtonText: "نعم",
          cancelButtonText: "لا",
          type: "warning",
          class: "rtl-dialog",
          customClass: "rtl-dialog",
          center: false,
        }
      ).catch(() => false);

      if (!confirmed) return;

      try {
        const params = {
          id: backup.id,
        };
        const { data } = await this.$axios.delete(`/api/backup/delete`, {
          params,
        });
        if (data.data) {
          this.$notify({
            timeout: 3000,
            message: "تم حذف النسخة الاحتياطية بنجاح",
            icon: "add_alert",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success",
          });
          this.tableData = this.tableData.filter((f) => f.id !== backup.id);
        }
      } catch (error) {
        this.$notify({
          timeout: 3000,
          message: "حدث خطأ أثناء حذف النسخة الاحتياطية",
          icon: "add_alert",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "error",
        });
      }
    },
    async handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      // Validate file type
      if (!file.type && !file.name.endsWith(".zip")) {
        this.$notify({
          timeout: 3000,
          message: "يرجى اختيار ملف بصيغة ZIP فقط",
          icon: "error",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "error",
        });
        event.target.value = "";
        return;
      }

      this.isUploading = true;
      try {
        const formData = new FormData();
        formData.append("backupFile", file);

        const { data } = await this.$axios.post(
          "/api/backup/localBackupUpload",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (data) {
          this.$notify({
            timeout: 1000,
            message: "تم رفع النسخة الاحتياطية بنجاح",
            icon: "add_alert",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success",
          });

          setTimeout(() => {
            localStorage.clear();
            this.$router.replace("/");
          }, 500); // 1 second delay
        }
      } catch (error) {
        this.$notify({
          timeout: 3000,
          message: error.response?.data?.message || "حدث خطأ أثناء رفع الملف",
          icon: "add_alert",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "error",
        });
      } finally {
        this.isUploading = false;
        // Reset the file input
        event.target.value = "";
      }
    },
  },
};
</script>

<style lang="scss">
.backup-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 1rem;

  .md-button {
    min-width: 200px;
    font-size: 1.1rem;
    .md-icon {
      margin-left: 8px;
      font-size: 1.2rem !important;
    }
  }
}

.download-section {
  margin-top: 1rem;
  text-align: center;

  .md-button {
    max-width: 300px;
    margin: 0 auto;
  }
}

.mb-8 {
  margin-bottom: 2rem;
}

.md-progress-spinner {
  margin-inline: 5px;
  ::v-deep .md-progress-spinner-circle {
    stroke: white !important;
  }
}

// .spinner-container {
//   display: inline-flex;
//   align-items: center;
//   justify-content: center;
//   width: 20px;
//   height: 20px;
//   margin-inline-end: 8px;

//   .md-progress-spinner {
//     position: absolute;
//   }
// }

// .md-button {
//   position: relative;

//   .md-progress-spinner {
//     ::v-deep .md-progress-spinner-circle {
//       stroke: currentColor !important;
//     }
//   }
// }

.el-message-box__wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-top: 50px;
  .rtl-dialog {
    direction: rtl;
    text-align: right;
    top: 10px;

    .el-message-box__header {
      padding-right: 20px;
      padding-left: 0;
    }

    .el-message-box__content {
      .el-message-box__container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        .el-message-box__message {
          margin-right: 20px;
        }
      }
    }

    .el-message-box__headerbtn {
      right: auto;
      left: 20px;
    }

    .el-message-box__btns {
      gap: 10px;
      display: flex;
      justify-content: flex-end;
      // direction: ltr;
      // justify-content: flex-end;
    }
  }
}

.alert-container {
  display: flex;
  justify-content: center;
}
</style>
